import React from "react";
import Hero from "../components/Hero";
import Video from "../components/Video";

const Home: React.FC = () => {
  return (
    <>
      <Hero />
      <Video />
    </>
  );
};

export default Home;
